import { cn } from "@/lib/cn"
import { ComponentPropsWithRef } from "react"

export type InputProps = ComponentPropsWithRef<"input">

export function Input({
  placeholder = " ",
  type = "text",
  className,
  ref,
  ...props
}: InputProps) {
  const isSnai = window.APP_VENDOR === "snai"

  const snaiInputStyle =
    "peer rounded-field border-field border-field-border bg-field-background focus:group-data-[ui-state=idle]:border-field-border-focus group-data-[ui-state=error]:border-field-error-border group-data-[ui-state=warn]:border-field-warning group-data-[ui-state=error]:bg-field-error-background group-data-[ui-state=warn]:bg-field-error-background focus:group-data-[ui-state=idle]:ring-field-ring-focus block h-11 w-full appearance-none border-solid pr-[.625rem] pl-[.8125rem] text-base font-normal focus:outline-hidden focus:group-data-[ui-state=idle]:ring-4"
  const defaultInputStyle =
    "peer rounded-field border-field border-field-border bg-field-background focus:group-data-[ui-state=idle]:border-field-border-focus group-data-[ui-state=error]:border-field-error group-data-[ui-state=warn]:border-field-warning group-data-[ui-state=error]:bg-field-error-background group-data-[ui-state=warn]:bg-field-error-background focus:group-data-[ui-state=idle]:ring-field-ring-focus block h-11 w-full appearance-none border-solid pr-[.625rem] pl-[.8125rem] text-base focus:outline-hidden focus:group-data-[ui-state=idle]:ring-4"
  return (
    <input
      placeholder={placeholder}
      type={type}
      className={cn(isSnai ? snaiInputStyle : defaultInputStyle, className)}
      ref={ref}
      {...props}
    />
  )
}
